  export const text = {
    en: {
      // Header
      title: "Employee Management System",
      subtitle: "Comprehensive management of employee data and status tracking",

      // Buttons
      selectDepartment: "Select Department",
      addEmployee: "Add New Employee",
      add: "Add",
      import: "Import Excel",
      export: "Export Excel",
      share: "Share",
      archive: "View Archive",
      cancel: "Cancel",
      update: "Update Employee",
      save: "Save",
      delete: "Delete",
      restore: "Restore",
      restoreAll: "Restore All",
      deleteAll: "Delete All",
      updating: "Updating...",
      adding: "Adding...",
      exportTemplate: "Export Template",
      templateExported: "Template exported successfully!",
      employeeListDescription: "Manage and view all employees",
      // Table Headers
      employee: "Employee",
      department: "Department",
      salary: "Salary",
      joinDate: "Join Date",
      status: "Status",
      actions: "Actions",
      archivedDate: "Archived Date",
      company: "Company",

      // Departments
      infotech: "Information Technology",
      humanResources: "Human Resources",
      finance: "Finance",
      marketing: "Marketing",
      operations: "Operations",
      sales: "Sales",
      customerService: "Customer Service",

      // Filters
      filtersActions: "Filters & Actions",
      showing: "Showing",
      of: "of",
      records: "records",
      searchEmployee: "Search Employee",
      allDepartments: "All Departments",
      allStatuses: "All Statuses",
      allCompanies: "All Companies",
      searchDepartment: "Search Department",
      selectStatus: "Select Status",

      // Stats
      totalEmployees: "Total Employees",
      activeEmployees: "Active Employees",
      onLeave: "On Leave",
      archived: "Archived",
      newEmployees: "New Employees",
      total: "Total",
      active: "Active",
      currentlyWorking: "Currently working",
      currentlyOnLeave: "Currently on leave",
      archivedEmployees: "Archived Employees",
      joinedRecently: "Joined Recently",
      allRegisteredEmployees: "All registered employees",
      allEmployees: "All employees",

      // Status
      statusActive: "Active",
      statusOnLeave: "On Leave",
      statusInactive: "Inactive",
      statusArchived: "Archived",
      statusUnknown: "Unknown",

      // Messages
      loading: "Loading...",
      loadingEmployees: "Loading employees...",
      noEmployees: "No employees found",
      noArchivedEmployees: "No archived employees found",
      employeesArchivedMessage: "Employees that are archived will appear here",
      showAll: "Show All",
      showLess: "Show Less",
      more: "more",

      // Modals
      employeeDetails: "Employee Details",
      editEmployee: "Edit Employee",
      addNewEmployee: "Add New Employee",
      viewArchive: "Archived",
      archivedDescription:
        "Archived employees are safely stored here. You can restore them to active status or permanently delete them.",

      // Form Labels
      fullName: "ُEnglish Name",
      arabicName: "Arabic Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      nationalId: "National ID",
      position: "Position",
      laborMode: "Labor Mode",
      companyName: "Company",
      clientCode: "Client Code",
      statusLabel: "Status",
      salaryLabel: "Salary",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      maritalStatus: "Marital Status",
      nationality: "Nationality",
      city: "City",
      country: "Country",
      address: "Address",
      emergencyPhone: "Emergency Phone",

      // Form Placeholders
      enterFullName: "Enter full name",
      enterEmail: "Enter email address",
      enterPhone: "Enter phone number",
      enterNationalId: "Enter national ID",
      enterPosition: "Enter position",
      enterCompany: "Enter company name",
      enterClientCode: "Enter client code",
      enterSalary: "Enter salary amount",
      selectGender: "Select Gender",
      selectMaritalStatus: "Select Status",
      enterNationality: "Enter nationality",
      enterCity: "Enter city",
      enterCountry: "Enter country",
      enterAddress: "Enter full address",
      searchNameIdEmail: "Name, ID, email...",
      searchNameId: "Name, ID...",

      // Form Sections
      basicInformation: "Basic Information",
      workInformation: "Work Information",
      personalInformation: "Personal Information",
      contactInformation: "Contact Information",
      educationInformation: "Education Information",
      insuranceInformation: "Insurance Information",
      systemInformation: "System Information",

      // Gender Options
      male: "Male",
      female: "Female",

      // Marital Status Options
      single: "Single",
      married: "Married",
      divorced: "Divorced",
      widowed: "Widowed",

      // Labor Mode Options (insource vs outsource)
      insource: "Insource",
      outsource: "Outsource",

      // Last Contract Term Options
      fullTime: "Full-time",
      partTime: "Part-time",
      contract: "Contract",
      temporary: "Temporary",
      freelance: "Freelance",

      // Info Labels
      email: "Email",
      phone: "Phone",
      employeeId: "Employee ID",
      hiringDate: "Hiring Date",
      netSalary: "Net Salary",
      workingExperience: "Working Experience",
      contractDate: "Contract Date",
      contractExpiration: "Contract Expiration",
      termOfContract: "Term of Contract",
      insuranceStatus: "Insurance Status",
      insuranceNumber: "Insurance Number",
      insuranceSalary: "Insurance Salary",
      insuranceStartDate: "Insurance Start Date",
      monthsForInsurance: "Months for Insurance",
      graduateInstitution: "Graduate Institution",
      major: "Major",
      graduationYear: "Graduation Year",
      createdAt: "Created At",
      lastUpdated: "Last Updated",
      years: "years",
      months: "months",

      // Action Buttons
      viewDetails: "View Details",
      editEmployee: "Edit Employee",
      deleteEmployee: "Delete Employee",
      archiveEmployee: "Archive Employee",
      restoreEmployee: "Restore Employee",
      permanentlyDelete: "Permanently Delete",

      // Confirmation Messages
      confirmDelete: "Are you sure you want to delete this employee?",
      confirmDeletee: "Delete Employee",

      confirmArchive: "Are you sure you want to archive this employee?",
      confirmRestore: "Are you sure you want to restore this employee?",
      confirmRestoree: "Restore Employee",
      confirmPermanentDelete:
        "Are you sure you want to permanently delete this employee? This action cannot be undone.",
      confirmRestoreAll: "Are you sure you want to restore all",
      archivedEmployeesQuestion: "archived employees?",
      confirmDeleteAll: "Are you sure you want to permanently delete all",
      cannotBeUndone: "This action cannot be undone.",

      // Success Messages
      employeeUpdated: "Employee updated successfully!",
      employeeAdded: "Employee added successfully!",
      employeeDeleted: "Employee deleted successfully!",
      employeeArchived: "Employee archived successfully!",
      employeeRestored: "Employee restored successfully!",
      allEmployeesDeleted: "All archived employees permanently deleted!",
      exportSuccess: "Exported",
      filteredEmployees: "filtered employees successfully!",
      exportSuccessCSV: "filtered employees as CSV!",
      exporting: "Exporting...",
      noEmployeesToExport: "No employees to export",
      employees: "employees",

      // Error Messages
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Email is invalid",
      emailOrPhoneRequired: "Email or phone number is required",
      emailOrPhoneHint: "* Either an email address or a phone number is required.",
      departmentRequired: "Department is required",
      positionRequired: "Position is required",
      failedToFetch: "Failed to fetch employee",
      failedToUpdate: "Failed to update employee",
      failedToAdd: "Failed to add employee",
      failedToDelete: "Failed to delete employee",
      failedToArchive: "Failed to archive employee",
      failedToRestore: "Failed to restore employee",
      failedToExport: "Failed to export employees data",
      serverError: "Server error during import",
      importFailed: "Import failed:",
      Status: "Status",

      // Archive Stats
      totalArchived: "Total Archived",
      archivedThisMonth: "Archived This Month",
      archivedEmployee: "archived employee",
      archivedEmployees: "archived employees",

      // Import Messages
      imported: "Imported",
      updated: "Updated",
      skipped: "Skipped",
      employeesSuccessfully: "employees successfully.",
      failedRows: "Failed rows:",
      duplicateReviewTitle: "Duplicate Review Required",
      duplicateReviewHint: "Choose for each duplicate whether to keep existing system data or update with Excel data.",
      keepExisting: "Keep existing",
      useIncoming: "Use Excel data",
      applyAllKeepExisting: "Apply all: Keep existing",
      applyAllUseIncoming: "Apply all: Use Excel data",
      clearAllDecisions: "Clear all decisions",
      proceedImport: "Proceed Import",
      reviewingImport: "Reviewing import file...",
      processingImport: "Processing import...",
      duplicateNeedsDecision: "Please choose a decision for all duplicates before continuing.",
      duplicateKey: "Duplicate Key",
      noPreviewDuplicates: "No duplicates found in preview.",
      row: "Row",
      validationErrorsTitle: "Required Field Errors",
      validationErrorsHint: "The following rows have missing required fields (Infinity Code, Client Code, Email) and were not imported.",
      missingFieldsLabel: "Missing Fields",
      noValidationErrors: "No required-field errors.",
      parseWarningsTitle: "Parse Warnings",
      parseWarningsHint: "The following rows were imported, but some field values could not be converted to the correct format and were saved as empty.",
      parseWarningField: "Field",
      parseWarningValue: "Entered Value",
      parseWarningExpected: "Expected Format",
      noParseWarnings: "No parse warnings.",
      errorsAndWarnings: "Errors & Warnings",
      nextReviewDuplicates: "Next: Review Duplicates →",
      backToErrors: "← Back",
      fieldsDiffLabel: "fields changed",
      hideDiffs: "Hide differences",
      fieldColumn: "Field",
      changedFields: "Changed Fields",

      // List Labels
      employeeList: "Employee List",
      employeesCount: "employees",
      employees: "Employees",

      viewDocuments: "View Documents",
      documents: "Documents",
      noDocuments: "No documents found",
      download: "Download",
      documentChecklist: "Document Checklist",
      failedToUpdateDocuments: "Failed to update documents",

      // New Field Labels
      idRegion: "ID Region",
      religion: "Religion",
      arabicAddress: "Arabic Address",
      workingCompany: "Working Company",
      contractCompany: "Contract Company",
      additionalCompensation: "Additional Compensation",
      transportationAllowances: "Transportation Allowances",
      variableSalary: "Variable Salary",
      firstLineManagerCode: "First Line Manager Client Code",
      firstLineManagerName: "First Line Manager Name",
      secondLineManagerCode: "Second Line Manager Code",
      secondLineManagerName: "Second Line Manager",
      lastContractDate: "Last Contract Date",
      lastContractTerm: "Last Contract Term",
      lastContractExpiration: "Last Contract Expiration",
      periodForBeingRegular: "Period for Being Regular",
      beRegularDate: "Be-Regular Date",
      toBeRegular: "To Be Regular",
      medicalInsuranceStage: "Medical Insurance Stage",
      medicalNumber: "Medical Number",
      uniformSize: "Uniform Size",
      drivingLicenseDegree: "Driving License Degree",
      drivingLicenseExpiry: "Driving License Expiry",
      militaryStatus: "Military Status",
      age: "Age",
      resignedDate: "Resigned Date",
      resignReasons: "Resign Reasons",
      contractInformation: "Contract Information",
      hrInformation: "HR Information",
      enterIdRegion: "Enter ID region",
      enterReligion: "Enter religion",
      enterArabicAddress: "Enter Arabic address",
      enterWorkingCompany: "Enter working company",
      selectWorkingCompany: "Select working company",
      selectWorkingCompanyFirst: "Select working company first",
      enterContractCompany: "Enter contract company",
      enterTransportation: "Enter transportation allowances",
      enterVariableSalary: "Enter variable salary",
      enterFirstLineCode: "Enter manager code",
      enterFirstLineName: "Enter manager name",
      enterSecondLineCode: "Enter manager code",
      enterSecondLineName: "Enter manager name",
      enterLastContractTerm: "Enter term (months)",
      enterPeriodForRegular: "Enter period",
      enterMedicalStage: "Enter medical insurance stage",
      enterMedicalNumber: "Enter medical number",
      enterUniformSize: "Enter uniform size",
      enterLicenseDegree: "Enter driving license degree",
      enterAge: "Enter age",
      enterResignReasons: "Enter resign reasons",

      // Not Available
      na: "N/A",
      exportArchive: "Export Archive",
      archiveSearchPlaceholder: "Search by name, ID, or email...",
      archiveFilterCompany: "Client Company",
      archiveFilterWorkingCompany: "Working Company",
      archiveFilterDepartment: "Department",
      archiveDateFrom: "Archived from",
      archiveDateTo: "Archived to",
      clearArchiveFilters: "Clear Filters",
      exportingArchive: "Exporting...",
    },
    ar: {
      // Header
      title: "نظام إدارة الموظفين",
      subtitle: "إدارة شاملة لبيانات الموظفين وتتبع الحالة",

      // Buttons
      selectDepartment: "اختر القسم",
      addEmployee: "إضافة موظف جديد",
      add: "إضافة",
      import: "رفع إكسل",
      export: "تحميل الإكسل",
      share: "مشاركة",
      archive: "عرض الأرشيف",
      cancel: "إلغاء",
      update: "تحديث الموظف",
      save: "حفظ",
      delete: "حذف",
      restore: "استعادة",
      restoreAll: "استعادة الكل",
      deleteAll: "حذف الكل",
      updating: "جاري التحديث...",
      adding: "جاري الإضافة...",
      exportTemplate: "تحميل  القالب",
      templateExported: "تم تحميل  القالب بنجاح!",
      employeeListDescription: "إدارة وعرض جميع الموظفين",
      // Table Headers
      employee: "الموظف",
      department: "القسم",
      salary: "الراتب",
      joinDate: "تاريخ التعيين",
      status: "الحالة",
      actions: "الإجراءات",
      archivedDate: "تاريخ الأرشفة",
      company: "الشركة",

      // Departments
      infotech: "تكنولوجيا المعلومات",
      humanResources: "الموارد البشرية",
      finance: "المالية",
      marketing: "التسويق",
      operations: "العمليات",
      sales: "المبيعات",
      customerService: "خدمة العملاء",

      // Filters
      filtersActions: "الفلاتر والإجراءات",
      showing: "عرض",
      of: "من",
      records: "سجل",
      searchEmployee: "بحث عن موظف",
      allDepartments: "جميع الأقسام",
      Status: "الحالة",
      allStatuses: "جميع الحالات",
      allCompanies: "جميع الشركات",
      searchDepartment: "اختر القسم",
      selectStatus: "اختر الحالة",

      // Stats
      totalEmployees: "إجمالي الموظفين",
      activeEmployees: "الموظفون النشطون",
      onLeave: "في إجازة",
      archived: "المؤرشف",
      newEmployees: "موظفون جدد",
      total: "الإجمالي",
      active: "نشط",
      currentlyWorking: "يعملون حالياً",
      currentlyOnLeave: "في إجازة حالياً",
      archivedEmployees: "الأرشيف",
      joinedRecently: "انضموا مؤخراً",
      allRegisteredEmployees: "جميع الموظفين المسجلين",
      allEmployees: "جميع الموظفين",

      // Status
      statusActive: "نشط",
      statusOnLeave: "في إجازة",
      statusInactive: "غير نشط",
      statusArchived: "مؤرشف",
      statusUnknown: "غير معروف",

      // Messages
      loading: "جاري التحميل...",
      loadingEmployees: "جاري تحميل الموظفين...",
      noEmployees: "لا يوجد موظفون",
      noArchivedEmployees: "لا يوجد موظفون مؤرشفون",
      employeesArchivedMessage: "الأرشيف سيظهرون هنا",
      showAll: "عرض الكل",
      showLess: "عرض أقل",
      more: "المزيد",

      // Modals
      employeeDetails: "تفاصيل الموظف",
      editEmployee: "تعديل الموظف",
      addNewEmployee: "إضافة موظف جديد",
      viewArchive: "الأرشيف",
      archivedDescription:
        "الأرشيف محفوظون هنا بأمان. يمكنك استعادتهم إلى الحالة النشطة أو حذفهم نهائياً.",

      // Form Labels
      fullName: "الاسم بالانجليزي",
      arabicName: "الاسم بالعربي",
      emailAddress: "البريد الإلكتروني",
      phoneNumber: "رقم الهاتف",
      nationalId: "الرقم القومي",
      position: "المنصب",
      laborMode: "نوع العمل",
      companyName: "الشركة",
      clientCode: "كود العميل",
      statusLabel: "الحالة",
      salaryLabel: "الراتب",
      dateOfBirth: "تاريخ الميلاد",
      gender: "النوع",
      maritalStatus: "الحالة الاجتماعية",
      nationality: "الجنسية",
      city: "المدينة",
      country: "الدولة",
      address: "العنوان",
      emergencyPhone: "هاتف الطوارئ",

      // Form Placeholders
      enterFullName: "أدخل الاسم بالانجليزي",
      enterEmail: "أدخل البريد الإلكتروني",
      enterPhone: "أدخل رقم الهاتف",
      enterNationalId: "أدخل الرقم القومي",
      enterPosition: "أدخل المنصب",
      enterCompany: "أدخل اسم الشركة",
      enterClientCode: "أدخل كود العميل",
      enterSalary: "أدخل قيمة الراتب",
      selectGender: "اختر النوع",
      selectMaritalStatus: "اختر الحالة",
      enterNationality: "أدخل الجنسية",
      enterCity: "أدخل المدينة",
      enterCountry: "أدخل الدولة",
      enterAddress: "أدخل العنوان الكامل",
      searchNameIdEmail: "الاسم، الرقم، البريد...",
      searchNameId: "الاسم، الرقم...",

      // Form Sections
      basicInformation: "المعلومات الأساسية",
      workInformation: "معلومات العمل",
      personalInformation: "المعلومات الشخصية",
      contactInformation: "معلومات الاتصال",
      educationInformation: "المعلومات التعليمية",
      insuranceInformation: "معلومات التأمين",
      systemInformation: "معلومات النظام",

      // Gender Options
      male: "ذكر",
      female: "أنثى",

      // Marital Status Options
      single: "أعزب",
      married: "متزوج",
      divorced: "مطلق",
      widowed: "أرمل",

      // Labor Mode Options (insource vs outsource)
      insource: "داخلي (توظيف مباشر)",
      outsource: "خارجي (تعاقد)",

      // Last Contract Term Options
      fullTime: "دوام كامل",
      partTime: "دوام جزئي",
      contract: "عقد",
      temporary: "مؤقت",
      freelance: "عمل حر",

      // Info Labels
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      employeeId: "رقم الموظف",
      hiringDate: "تاريخ التعيين",
      netSalary: "صافي الراتب",
      workingExperience: "الخبرة العملية",
      contractDate: "تاريخ العقد",
      contractExpiration: "انتهاء العقد",
      termOfContract: "مدة العقد",
      insuranceStatus: "حالة التأمين",
      insuranceNumber: "رقم التأمين",
      insuranceSalary: "راتب التأمين",
      insuranceStartDate: "تاريخ بدء التأمين",
      monthsForInsurance: "أشهر التأمين",
      graduateInstitution: "المؤسسة التعليمية",
      major: "التخصص",
      graduationYear: "سنة التخرج",
      createdAt: "تاريخ الإنشاء",
      lastUpdated: "آخر تحديث",
      years: "سنوات",
      months: "أشهر",

      // Action Buttons
      viewDetails: "عرض التفاصيل",
      editEmployee: "تعديل الموظف",
      deleteEmployee: "حذف الموظف",
      archiveEmployee: "أرشفة الموظف",
      restoreEmployee: "استعادة الموظف",
      permanentlyDelete: "حذف نهائي",
      confirmDeletee: "حذف الموظف",


      // Confirmation Messages
      confirmDelete: "هل أنت متأكد من حذف هذا الموظف؟",
      confirmArchive: "هل أنت متأكد من أرشفة هذا الموظف؟",
      confirmRestore: "هل أنت متأكد من استعادة هذا الموظف؟",
      confirmRestoree: "استعادة الموظف",
      confirmPermanentDelete:
        "هل أنت متأكد من الحذف النهائي لهذا الموظف؟ لا يمكن التراجع عن هذا الإجراء.",
      confirmRestoreAll: "هل أنت متأكد من استعادة كل",
      archivedEmployeesQuestion: "الموظفين المؤرشفين؟",
      confirmDeleteAll: "هل أنت متأكد من الحذف النهائي لكل",
      cannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",

      // Success Messages
      employeeUpdated: "تم تحديث الموظف بنجاح!",
      employeeAdded: "تم إضافة الموظف بنجاح!",
      employeeDeleted: "تم حذف الموظف بنجاح!",
      employeeArchived: "تم أرشفة الموظف بنجاح!",
      employeeRestored: "تم استعادة الموظف بنجاح!",
      allEmployeesDeleted: "تم حذف جميع الموظفين المؤرشفين نهائياً!",
      exportSuccess: "تم تحميل ",
      filteredEmployees: "الموظفين المفلترين بنجاح!",
      exportSuccessCSV: "الموظفين المفلترين كملف CSV!",
      exporting: "جاري التحميل...",
      noEmployeesToExport: "لا يوجد موظفين للتحميل",
      employees: "موظفين",

      // Error Messages
      nameRequired: "الاسم مطلوب",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailInvalid: "البريد الإلكتروني غير صحيح",
      emailOrPhoneRequired: "البريد الإلكتروني أو رقم الهاتف مطلوب",
      emailOrPhoneHint: "* يجب إدخال بريد إلكتروني أو رقم هاتف على الأقل.",
      departmentRequired: "القسم مطلوب",
      positionRequired: "المنصب مطلوب",
      failedToFetch: "فشل في جلب بيانات الموظف",
      failedToUpdate: "فشل في تحديث الموظف",
      failedToAdd: "فشل في إضافة الموظف",
      failedToDelete: "فشل في حذف الموظف",
      failedToArchive: "فشل في أرشفة الموظف",
      failedToRestore: "فشل في استعادة الموظف",
      failedToExport: "فشل في تحميل  بيانات الموظفين",
      serverError: "خطأ في الخادم أثناء الاستيراد",
      importFailed: "فشل الاستيراد:",

      // Archive Stats
      totalArchived: "إجمالي المؤرشف",
      archivedThisMonth: "المؤرشف هذا الشهر",
      archivedEmployee: "موظف مؤرشف",
      archivedEmployees: "موظفين مؤرشفين",

      // Import Messages
      imported: "تم استيراد",
      updated: "تم تحديث",
      skipped: "تم تخطي",
      employeesSuccessfully: "موظف بنجاح.",
      failedRows: "صفوف فاشلة:",
      duplicateReviewTitle: "مراجعة التكرارات مطلوبة",
      duplicateReviewHint: "اختر لكل سجل مكرر هل تريد الإبقاء على بيانات النظام أو التحديث من ملف الإكسل.",
      keepExisting: "الإبقاء على البيانات الحالية",
      useIncoming: "استخدام بيانات الإكسل",
      applyAllKeepExisting: "تطبيق على الكل: الإبقاء على الحالي",
      applyAllUseIncoming: "تطبيق على الكل: استخدام بيانات الإكسل",
      clearAllDecisions: "مسح كل الاختيارات",
      proceedImport: "بدء الاستيراد",
      reviewingImport: "جاري مراجعة ملف الاستيراد...",
      processingImport: "جاري تنفيذ الاستيراد...",
      duplicateNeedsDecision: "يرجى اختيار قرار لكل السجلات المكررة قبل المتابعة.",
      duplicateKey: "مفتاح التكرار",
      noPreviewDuplicates: "لا توجد تكرارات في المعاينة.",
      row: "صف",
      validationErrorsTitle: "أخطاء الحقول المطلوبة",
      validationErrorsHint: "الصفوف التالية تحتوي على حقول مطلوبة مفقودة (كود إنفينيتي، كود العميل، البريد الإلكتروني) ولم يتم استيرادها.",
      missingFieldsLabel: "الحقول المفقودة",
      noValidationErrors: "لا توجد أخطاء في الحقول المطلوبة.",
      parseWarningsTitle: "تحذيرات التحليل",
      parseWarningsHint: "الصفوف التالية تم استيرادها، لكن بعض القيم لم يتمكن من تحويلها إلى النوع الصحيح وتم حفظها فارغة.",
      parseWarningField: "الحقل",
      parseWarningValue: "القيمة المدخلة",
      parseWarningExpected: "النوع المتوقع",
      noParseWarnings: "لا توجد تحذيرات تحليل.",
      errorsAndWarnings: "الأخطاء والتحذيرات",
      nextReviewDuplicates: "التالي: مراجعة المكررات →",
      backToErrors: "→ رجوع",
      fieldsDiffLabel: "حقول تختلف",
      hideDiffs: "إخفاء الفروقات",
      fieldColumn: "الحقل",
      changedFields: "الحقول المتغيرة",

      // List Labels
      employeeList: "قائمة الموظفين",
      employeesCount: "موظف",
      employees: "الموظفين",


      viewDocuments: "عرض المستندات",
      documents: "المستندات",
      noDocuments: "لا توجد مستندات",
      download: "تحميل",
      documentChecklist: "قائمة فحص المستندات",
      failedToUpdateDocuments: "فشل في تحديث المستندات",

      // New Field Labels
      idRegion: "منطقة الهوية",
      religion: "الديانة",
      arabicAddress: "العنوان بالعربي",
      workingCompany: "شركة العمل",
      contractCompany: "شركة التعاقد",
      additionalCompensation: "تعويضات إضافية",
      transportationAllowances: "بدل المواصلات",
      variableSalary: "الراتب المتغير",
      firstLineManagerCode: "كود المدير المباشر (كود العميل)",
      firstLineManagerName: "اسم المدير المباشر",
      secondLineManagerCode: "كود المدير الثاني",
      secondLineManagerName: "المدير الثاني",
      lastContractDate: "تاريخ آخر عقد",
      lastContractTerm: "مدة آخر عقد",
      lastContractExpiration: "انتهاء آخر عقد",
      periodForBeingRegular: "فترة التثبيت",
      beRegularDate: "تاريخ التثبيت",
      toBeRegular: "سيتم تثبيته",
      medicalInsuranceStage: "مرحلة التأمين الطبي",
      medicalNumber: "رقم التأمين الطبي",
      uniformSize: "مقاس الزي",
      drivingLicenseDegree: "درجة رخصة القيادة",
      drivingLicenseExpiry: "انتهاء رخصة القيادة",
      militaryStatus: "الحالة العسكرية",
      age: "العمر",
      resignedDate: "تاريخ الاستقالة",
      resignReasons: "أسباب الاستقالة",
      contractInformation: "معلومات العقد",
      hrInformation: "معلومات الموارد البشرية",
      enterIdRegion: "أدخل منطقة الهوية",
      enterReligion: "أدخل الديانة",
      enterArabicAddress: "أدخل العنوان بالعربي",
      enterWorkingCompany: "أدخل شركة العمل",
      selectWorkingCompany: "اختر شركة العمل",
      selectWorkingCompanyFirst: "اختر شركة العمل أولاً",
      enterContractCompany: "أدخل شركة التعاقد",
      enterTransportation: "أدخل بدل المواصلات",
      enterVariableSalary: "أدخل الراتب المتغير",
      enterFirstLineCode: "أدخل كود المدير",
      enterFirstLineName: "أدخل اسم المدير",
      enterSecondLineCode: "أدخل كود المدير",
      enterSecondLineName: "أدخل اسم المدير",
      enterLastContractTerm: "أدخل المدة (بالأشهر)",
      enterPeriodForRegular: "أدخل الفترة",
      enterMedicalStage: "أدخل مرحلة التأمين الطبي",
      enterMedicalNumber: "أدخل رقم التأمين الطبي",
      enterUniformSize: "أدخل مقاس الزي",
      enterLicenseDegree: "أدخل درجة رخصة القيادة",
      enterAge: "أدخل العمر",
      enterResignReasons: "أدخل أسباب الاستقالة",

      // Not Available
      na: "غير متاح",
      exportArchive: "تحميل الأرشيف",
      archiveSearchPlaceholder: "بحث بالاسم أو الرقم أو البريد...",
      archiveFilterCompany: "شركة العميل",
      archiveFilterWorkingCompany: "شركة العمل",
      archiveFilterDepartment: "القسم",
      archiveDateFrom: "مؤرشف من",
      archiveDateTo: "مؤرشف إلى",
      clearArchiveFilters: "مسح الفلاتر",
      exportingArchive: "جاري التحميل...",
    },
  };